<template>
    <Section
        #default="{ data: validators, isResolving, isResolved, isRejected, execute }"
        endpoint="entities.validators"
        :transform="transform"
    >
        <div class="Wrapper">
            <WText
                tag="label"
                typo="label"
                size="14"
            >
                {{ $t('entities.creation.labels.validators') }}
            </WText>
            <div v-if="!isRejected">
                <FadeHeightTransitionGroup tag="div">
                    <div
                        v-for="key in normalizeValue"
                        :key="key"
                        class="flex row-stretch-center Item"
                        :class="{ bordered: (validators[key] || {}).name}"
                    >
                        <WText
                            color="gray"
                            :size="14"
                        >
                            {{ (validators[key] || {}).name }}
                        </WText>

                        <template v-if="(validators[key] || {}).type === inputs.BOOL">
                            <WSwitch
                                :value="value[key]"
                                :name="key"
                                :disabled="isLoading || isResolving"
                                color="accent-blue"
                                @input="handleInput(key, $event)"
                            />
                        </template>
                        <template v-else-if="(validators[key] || {}).type === inputs.DATE">
                            <WDatepicker
                                :value="value[key]"
                                :name="key"
                                :readonly="isLoading || isResolving"
                                popoverDirection="left"
                                @input="handleInput(key, $event)"
                            />
                        </template>
                        <template v-else-if="(validators[key] || {}).type">
                            <WInput
                                :value="value[key]"
                                :disabled="isLoading || isResolving"
                                :type="(validators[key] || {}).type"
                                :name="key"
                                @input="handleInput(key, $event)"
                            />
                        </template>
                    </div>
                </FadeHeightTransitionGroup>
            </div>
            <WText
                v-else-if="isRejected"
                visible
            >
                {{ $t('actions.retry.text') }}
                <a @click="execute">{{ $t('actions.retry.link') }}</a>
            </WText>
        </div>
    </Section>
</template>

<script>
import VueTypes from 'vue-types'
import { Section } from '@/components'
import { INPUTS } from '@/entities/fields'
import { VALIDATORS } from './utils'

export default {
    name: 'Validators',
    components: {
        Section,
    },
    props: {
        value: VueTypes.shape(VueTypes.any).loose,
        isLoading: VueTypes.bool.def(false),
    },
    data () {
        return {
            inputs: INPUTS,
        }
    },
    computed: {
        normalizeValue () {
            return Object.keys(this.value)
        },
    },
    methods: {
        handleInput (key, value) {
            this.$emit('input', {
                ...this.value,
                [key]: value,
            })
        },
        transform ({ data }) {
            return data.reduce((acc, item) => ({
                ...acc,
                [item.key]: {
                    ...item,
                    type: (VALIDATORS[item.key] || {}).type,
                },
            }), [])
        },
    },
}
</script>

<style lang="scss" scoped>
.Item {
    width: 100%;
    padding: 8px 0;

    &.bordered + &.bordered {
        border-top: solid 1px $gray-05;
    }

    &::v-deep input {
        margin-bottom: 0px !important;
    }
}
</style>
